export var reduxKey = '@@StatusUpdate';
export var MAXIMUM_SHORT_STATUS_LENGTH = 110;
export var MAXIMUM_LONG_STATUS_LENGTH = 600;
export var MAXIMUM_STATUS_LENGTH = 640000;
export var MINIMUM_STATUS_LENGTH = 1; // requirement
export var NUMBER_OF_TIMES_TO_SHOW_TUTORIAL_SUBTITLE = 5;
//# sourceMappingURL=constants.js.map